<ngx-spinner type="ball-clip-rotate"> </ngx-spinner>
<app-nav></app-nav>
<router-outlet />
